import {Toaster} from 'react-hot-toast'
import ChatContainer from './layout/ChatContainer'
import {ChatProvider} from './Context'

function MsgBroadcast() {
  return (
    <ChatProvider>
      <ChatContainer />
      <Toaster />
    </ChatProvider>
  )
}

export default MsgBroadcast
